import { HELP_REQUEST_RECEIVED, HELP_REQUEST_DELETED, HELP_REQUEST_UNLOADED } from './types'
import api from 'api';

export const helpRequestReceived = data => ({
  type: HELP_REQUEST_RECEIVED,
  data
})

export const helpRequestDeleted = () => ({
  type: HELP_REQUEST_DELETED,
  data: {}
})

export const helpRequestUnload = () => ({
  type: HELP_REQUEST_UNLOADED
})

export const getLastHelpRequest = () => (dispatch) =>
  api.system.getLastHelpRequest().then( res => {
    dispatch(helpRequestReceived(res))
  })

export const sendHelpRequest = data => dispatch =>
  api.system.sendHelpRequest(data).then(res=>{
    dispatch(helpRequestReceived(res))
  })

export const unloadHelpRequest= () => dispatch => {
  dispatch(helpRequestUnload())
}

export const removeHelpRequest = () => dispatch =>
  api.system.removeHelpRequest().then(()=>{
    dispatch(helpRequestDeleted())
  })